import useMobileApp from '../mobile-app/useMobileApp';

const useModule = () => {
  const { isMobileApp } = useMobileApp();

  const executeModule = ({ mobile, web }: { mobile?: () => void; web?: () => void }) => {
    if (isMobileApp) {
      return mobile?.();
    }

    return web?.();
  };

  return {
    executeModule,
  };
};

export default useModule;
